<template>
  <v-app style="background-color:#f8f9fb">
    <v-dialog v-model="dialogConfirmacao" persistent max-width="520">
      <v-card>
        <v-card-title>Confirmar importação</v-card-title>
        <v-card-text>
          Deseja importar os indicadores Stratws para
          <strong>{{ empresaNomeConfirmacao }}</strong>
          no período de {{ dataInicialExibicao }} a {{ dataFinalExibicao }}?
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn color="grey darken-1" text @click="dialogConfirmacao = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="importando"
            @click="executarImportacao"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-col cols="12">
        <v-card elevation="0" class="px-5 py-1">
          <v-row class="custom-gray-background fill-width d-flex">
            <v-col cols="12" sm="6" md="3">
              <span>Data Inicial</span>
              <v-menu
                v-model="menuDataInicial"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataInicial"
                    label="Data Inicial"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo-inverted
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dataInicial"
                  :allowed-dates="dataInicialPermitida"
                  :min="dataMinimaPermitida"
                  :max="dataMaximaPermitida"
                  @input="onDataInicialSelecionada"
                  locale="pt-BR"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <span>Data Final</span>
              <v-text-field
                v-model="dataFinal"
                label="Data Final"
                prepend-inner-icon="mdi-calendar"
                readonly
                disabled
                dense
                solo-inverted
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <span>Empresa</span>
              <v-select
                v-model="selectedEmpresa"
                :items="empresasStratws"
                item-text="text"
                item-value="value"
                label="Empresa"
                dense
                solo-inverted
                no-data-text="Nenhuma empresa disponível"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <span>&nbsp;</span>
              <v-btn
                color="#4682B4"
                block
                height="40"
                style="font-size: 14px; font-weight: bold"
                :disabled="!empresasStratws.length || !selectedEmpresa || importando"
                :loading="importando"
                @click="solicitarConfirmacaoImportacao"
              >
                Importar indicadores
                <v-icon style="margin-left: 8px" dark>mdi-cloud-upload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-container>

    <v-container style="background-color:#eee" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-if="mensagemImportacao"
            :type="tipoMensagemImportacao"
            dense
            text
            class="mb-4"
          >
            {{ mensagemImportacao }}
          </v-alert>

          <base-material-card
            icon="mdi-history"
            title="Listagem dos últimos importados"
            color="blue"
            style="margin-top:20px !important; padding-top:10px !important"
            class="px-5 py-0"
          >
            <br />

            <v-data-table
              :headers="headersListagem"
              :items="ultimosImportados"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
              item-key="id"
              :loading="carregandoListagem"
              loading-text="Carregando listagem..."
            >
              <template v-slot:item.valor="{ item }">
                {{ formatarValor(item.valor) }}
              </template>

              <template v-slot:item.occurrence="{ item }">
                {{ formatarOccurrence(item.occurrence) }}
              </template>

              <template v-slot:item.sucesso="{ item }">
                <v-chip
                  v-if="item.sucesso === true"
                  small
                  color="success"
                  text-color="white"
                >
                  Sim
                </v-chip>
                <v-chip
                  v-else-if="item.sucesso === false"
                  small
                  color="error"
                  text-color="white"
                >
                  Não
                </v-chip>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:no-data>
                <div class="text-center py-4">
                  <p>Nenhum indicador importado encontrado.</p>
                </div>
              </template>
            </v-data-table>

            <br />
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Indicador from '../../services/indicadores'

const EMPRESAS_STRATWS = [
  { value: 'memorial', text: 'Memorial' },
  { value: 'previda', text: 'Previda' },
  { value: 'parque', text: 'Parque' },
  { value: 'versan', text: 'Versan' },
  { value: 'agreste', text: 'Agreste' },
  { value: 'melro', text: 'Melro' },
]

const HEADERS_LISTAGEM = [
  { text: 'Empresa', value: 'empresa', sortable: true },
  { text: 'Indicador ID', value: 'indicatorId', sortable: true },
  { text: 'Valor', value: 'valor', sortable: true },
  { text: 'Unidade', value: 'unidade', sortable: true },
  { text: 'Ocorrência', value: 'occurrence', sortable: true },
  { text: 'Tipo de valor', value: 'valueType', sortable: true },
  { text: 'Sucesso', value: 'sucesso', sortable: true },
]

export default {
  name: 'ImportacaoStratws',

  data() {
    return {
      menuDataInicial: false,
      dialogConfirmacao: false,
      dataInicial: null,
      dataFinal: null,
      selectedEmpresa: null,
      empresasStratws: EMPRESAS_STRATWS,
      importando: false,
      mensagemImportacao: '',
      tipoMensagemImportacao: 'info',
      ultimosImportados: [],
      carregandoListagem: false,
      headersListagem: HEADERS_LISTAGEM,
    };
  },

  computed: {
    dataMinimaPermitida() {
      const hoje = new Date();
      const mesAnterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
      return this.formatDateForPicker(mesAnterior);
    },

    dataMaximaPermitida() {
      const hoje = new Date();
      const ultimoDiaMesAtual = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      return this.formatDateForPicker(ultimoDiaMesAtual);
    },

    empresaNomeConfirmacao() {
      return (
        this.empresasStratws.find((e) => e.value === this.selectedEmpresa)?.text ||
        this.selectedEmpresa ||
        ''
      );
    },

    dataInicialExibicao() {
      return this.formatarDataExibicao(this.dataInicial);
    },

    dataFinalExibicao() {
      return this.formatarDataExibicao(this.dataFinal);
    },
  },

  mounted() {
    const hoje = new Date();
    const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.dataInicial = this.formatDateForPicker(primeiroDiaMes);
    this.atualizarDataFinal();

    if (this.empresasStratws.length === 1) {
      this.selectedEmpresa = this.empresasStratws[0].value;
    }

    this.carregarUltimosImportados();
  },

  watch: {
    dataInicial() {
      this.atualizarDataFinal();
    },
  },

  methods: {
    empresaSelecionadaValida() {
      return this.empresasStratws.some((empresa) => empresa.value === this.selectedEmpresa);
    },

    formatarValor(valor) {
      if (valor === null || valor === undefined) {
        return '';
      }
      return Number(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    formatarOccurrence(occurrence) {
      if (!occurrence) {
        return '';
      }
      const data = new Date(occurrence);
      if (Number.isNaN(data.getTime())) {
        return occurrence;
      }
      return data.toLocaleDateString('pt-BR');
    },

    formatDateForPicker(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatarDataExibicao(dataStr) {
      if (!dataStr) {
        return '';
      }
      const [year, month, day] = dataStr.split('-').map(Number);
      const data = new Date(year, month - 1, day);
      return data.toLocaleDateString('pt-BR');
    },

    dataInicialPermitida(date) {
      return date >= this.dataMinimaPermitida && date <= this.dataMaximaPermitida;
    },

    obterUltimoDiaDoMes(dataStr) {
      const [year, month] = dataStr.split('-').map(Number);
      const ultimoDia = new Date(year, month, 0);
      return this.formatDateForPicker(ultimoDia);
    },

    atualizarDataFinal() {
      if (this.dataInicial) {
        this.dataFinal = this.obterUltimoDiaDoMes(this.dataInicial);
      }
    },

    onDataInicialSelecionada() {
      this.menuDataInicial = false;
      this.atualizarDataFinal();
    },

    validarFormularioImportacao() {
      if (!this.selectedEmpresa) {
        this.mensagemImportacao = 'Selecione uma empresa.';
        this.tipoMensagemImportacao = 'warning';
        return false;
      }

      if (!this.empresaSelecionadaValida()) {
        this.mensagemImportacao = 'Selecione uma empresa válida da lista.';
        this.tipoMensagemImportacao = 'warning';
        return false;
      }

      if (!this.dataInicial || !this.dataInicialPermitida(this.dataInicial)) {
        this.mensagemImportacao = 'A data inicial deve ser do mês atual ou do mês anterior.';
        this.tipoMensagemImportacao = 'warning';
        return false;
      }

      return true;
    },

    solicitarConfirmacaoImportacao() {
      if (!this.validarFormularioImportacao()) {
        return;
      }

      this.mensagemImportacao = '';
      this.dialogConfirmacao = true;
    },

    async carregarUltimosImportados() {
      this.carregandoListagem = true;

      try {
        const response = await Indicador.empresasImportacaoStratws();
        this.ultimosImportados = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error('Erro ao carregar últimos importados Stratws:', error);
        this.ultimosImportados = [];
      } finally {
        this.carregandoListagem = false;
      }
    },

    extrairMensagemErro(error) {
      const data = error?.response?.data;
      if (typeof data === 'string') {
        return data;
      }
      if (data?.erro) {
        return data.erro;
      }
      if (data?.mensagem) {
        return data.mensagem;
      }
      return 'Erro ao importar indicadores Stratws. Tente novamente.';
    },

    async executarImportacao() {
      if (!this.validarFormularioImportacao()) {
        this.dialogConfirmacao = false;
        return;
      }

      this.importando = true;
      this.mensagemImportacao = '';

      try {
        await Indicador.importarIndicadoresStratws(
          this.dataInicial,
          this.dataFinal,
          this.selectedEmpresa
        );

        await this.carregarUltimosImportados();

        this.mensagemImportacao = `Importação Stratws concluída para ${this.empresaNomeConfirmacao}.`;
        this.tipoMensagemImportacao = 'success';
        this.dialogConfirmacao = false;
      } catch (error) {
        console.error('Erro ao importar indicadores Stratws:', error);
        this.mensagemImportacao = this.extrairMensagemErro(error);
        this.tipoMensagemImportacao = 'error';
        this.dialogConfirmacao = false;
      } finally {
        this.importando = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-gray-background {
  height: 80px;
}

.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}
</style>
